<div class="wrapper">
	<h3>{{ 'add_promo_dialog.promo_type.sot_dialog_title' | translate }}</h3>
	<p>
		{{ 'add_promo_dialog.promo_type.sot_dialog_description' | translate }}
		{{ promoCode?.code }}
	</p>
	<div>
		<canvas id="barcode"></canvas>
	</div>
	<ion-button (click)="dismiss()">
		{{ 'short_info.close' | translate }}
	</ion-button>
</div>
